import { render, staticRenderFns } from "./InstituteForm.vue?vue&type=template&id=1a2f865d"
import script from "./InstituteForm.vue?vue&type=script&lang=js"
export * from "./InstituteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports